import { useAppSelector } from "integrations/redux/hooks"
import { useInspectorPanel } from "./useInspectorPanel"
import { selectInspectorPanelState } from "features/popups/slice"

export function InspectorPanel() {
    const { entityId, plugin } = useInspectorPanel()
    const inspectorPanelState = useAppSelector(selectInspectorPanelState)

    if (!plugin || inspectorPanelState === "inactive") return null
    return <plugin.InspectorPanelComponent id={entityId} plugin={plugin} />
}
